import { useEffect, useState, useCallback } from "react";
import { useSearchParams } from "react-router-dom";


import { getApi } from "../../api/api";

import { SaleItemInterface } from "../../common/types/interfaces";
import { useScrollPagination } from "../../common/hooks/useScrollPagination";
import { useCityId } from "../../common/hooks/useCityId";

const PAGE_LIMIT = 24;

export const useItem = (categoryId?: number) => {
  const [searchParams] = useSearchParams();
  const search = searchParams.get("search") || "";
  const clusterTypeParam = searchParams.get("clusterType");
  const clusterType = clusterTypeParam ? Number(clusterTypeParam) : undefined;

 
 const cityId = useCityId()

  const [items, setItems] = useState<SaleItemInterface[]>([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [isFetching, setIsFetching] = useState(false);
  const [isFetchingMore, setIsFetchingMore] = useState(false);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);

  // Сброс при смене поиска / категории / типа / города
  useEffect(() => {
    setOffset(0);
    setHasMore(true);
  }, [search, categoryId, clusterType, cityId]);

  useEffect(() => {
    if (!hasMore && offset > 0) return;
    if (isFetching || isFetchingMore) return;

    let cancelled = false;

    if (offset === 0) {
      setIsFetching(true);
    } else {
      setIsFetchingMore(true);
    }

    getApi()
      .getItems({
        categoryId,
        search: search || undefined,
        limit: PAGE_LIMIT,
        offset,
        cityId,
        clusterType,
      })
      .then((res) => {
        if (!cancelled) {
          setItems((prev) =>
            offset === 0 ? res.data : [...prev, ...res.data],
          );
          setTotal(res.total);
          if (res.data.length < PAGE_LIMIT) setHasMore(false);
          setLoading(false);
        }
      })
      .catch(() => {
        if (!cancelled) {
          if (offset === 0) setItems([]);
          setHasMore(false);
          setLoading(false);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setIsFetching(false);
          setIsFetchingMore(false);
        }
      });

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, categoryId, clusterType, cityId, offset]);

  const loadMore = useCallback(() => {
    if (!isFetching && !isFetchingMore && hasMore) {
      setOffset((prev) => prev + PAGE_LIMIT);
    }
  }, [isFetching, isFetchingMore, hasMore]);

  const { lastItemRef } = useScrollPagination(
    hasMore,
    isFetchingMore,
    loadMore,
  );

  return {
    items,
    total,
    ready: !loading,
    isFetching,
    isFetchingMore,
    hasMore,
    loadMore,
    lastItemRef,
  };
};
